var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalCategoriesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13762",
    "data-name": "Group 13762",
    transform: "translate(9 -3.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    transform: "translate(-9 3.518)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    transform: "translate(-9 44.518)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    transform: "translate(32 3.518)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    transform: "translate(32 44.518)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCategoriesIcon);
export default __webpack_public_path__ + "static/media/totalCategoriesIcon.41c3080aca03d5c1bbaad8787fc7b6df.svg";
export { ForwardRef as ReactComponent };